export const trackListings = [
  {
    path: "music/",
    file: "bite_my_tongue.wav",
  },
  {
    path: "music/",
    file: "grift.wav",
  },
  {
    path: "music/",
    file: "inside_my_mind.wav",
  },
  {
    path: "music/",
    file: "magazines_&_bad_faith.wav",
  },
  {
    path: "music/",
    file: "not_another_day.wav",
  },
  {
    path: "music/",
    file: "out_of_tune.wav",
  },
  {
    path: "music/",
    file: "surveillance.wav",
  },
  {
    path: "music/",
    file: "the_ledge.wav",
  },
  {
    path: "music/",
    file: "waste_of_time.wav",
  },
  {
    path: "music/",
    file: "what_now.wav",
  },
  {
    path: "music/",
    file: "you_cant_win_too_young_to_die.wav",
  },
];
